import { matchesLocator, policyLocatorFor } from './policyTarget'
import { SettingsTableDialog } from './SettingsTableDialog'

interface PosPolicyDialogProps {
  channelId: number
  /** Channel name, or booking engine name when the channel id is the booking engine channel. */
  name: string
  onClose: () => void
}

/** Opens the policy of one POS (channel or booking engine) straight on its form. */
export function PosPolicyDialog({ channelId, name, onClose }: PosPolicyDialogProps) {
  const locator = policyLocatorFor(channelId, name)
  return <SettingsTableDialog tableKey={locator.tableKey} focusRow={(row) => matchesLocator(row, locator)} onClose={onClose} />
}
